/**
 * HTML completo do export Moodle (curso) e meta de sync remoto.
 * Separado do siteExport.js para não misturar runtimes.
 */

export function buildMoodleCourseDocument({ title, lang, bodyHtml, css, syncToken = '' }) {
  const safeTitle = String(title || 'Geppetto')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
  const htmlLang = lang === 'en' ? 'en' : 'pt-BR';
  const safeCss = String(css || '').replace(/<\/style>/gi, '\\3C \\2F style \\3E');
  const token = String(syncToken || '').trim();
  const syncMeta = /^[a-f0-9]{48}$/.test(token)
    ? `\n  <meta name="geppetto-course-sync" content="${token}">`
    : '';
  return `<!DOCTYPE html>
<html lang="${htmlLang}">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <meta name="generator" content="Geppetto Course Export">
  <meta http-equiv="x-ua-compatible" content="IE=edge">${syncMeta}
  <title>${safeTitle}</title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css">
  <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
  <style>html,body{width:100%;min-width:100%;margin:0;padding:0;background:transparent;overflow:hidden;box-sizing:border-box}html*,html*::before,html*::after{box-sizing:border-box}</style>
  <style>${safeCss}</style>
</head>
<body>
  ${bodyHtml}
</body>
</html>`;
}

export function injectMoodleCourseSyncMeta(documentHtml, token) {
  const html = String(documentHtml || '');
  const tok = String(token || '').trim();
  if (!/^[a-f0-9]{48}$/.test(tok)) return html;
  if (/name=["']geppetto-course-sync["']/i.test(html)) {
    return html.replace(
      /(<meta\s+name=["']geppetto-course-sync["']\s+content=["'])[a-f0-9]{48}(["'])/i,
      `$1${tok}$2`
    );
  }
  if (html.includes('</head>')) {
    return html.replace('</head>', `  <meta name="geppetto-course-sync" content="${tok}">\n</head>`);
  }
  return `<meta name="geppetto-course-sync" content="${tok}">\n${html}`;
}
